export default __webpack_public_path__ + "img/cfaEFyof.75db5d4c.svg";